import { Controller } from "@hotwired/stimulus"

// Reusable tag input controller for dropdown submenus.
// Submits a form when the user presses Enter in the input field.
//
// Usage:
//   <div data-controller="tag-input">
//     <form ...>
//       <input data-tag-input-target="input"
//              data-action="keydown->tag-input#submitOnEnter">
//     </form>
//   </div>
export default class extends Controller {
  static targets = ["input"]

  submitOnEnter(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      const form = this.inputTarget.closest("form")
      if (form && this.inputTarget.value.trim()) {
        form.requestSubmit()
      }
    }
  }
}
